import * as Blockly from 'blockly/core';

class VMTConnectionChecker extends Blockly.ConnectionChecker {
    /**
     * Constructor for the connection checker.
     */
    // eslint-disable-next-line no-useless-constructor
    constructor(workspace) {
        console.log('VMTConnectionChecker', workspace);
        super();
    }

    /**
     * Type check arrays must either intersect or both be null.
     * @param {!Blockly.Connection} a The first connection to check.
     * @param {!Blockly.Connection} b The second connection to check.
     * @return {boolean} True if the connections are compatible.
     * @override
     */
    doTypeChecks(a, b) {
        // console.log('doTypeChecks', a, b);

        const checkArrayOne = a.getCheck() || ['null', 'String', 'Number'];
        const checkArrayTwo = b.getCheck() || ['null', 'String', 'Number'];

        // Rule #0 - parameter reference can only connect within the same reusable block
        // excluding nested reusable blocks
        const blockOne = a.getSourceBlock();
        if (blockOne.type === 'vmt_parameter_reference') {
            /** @type {{type: string, name: string, paramId: string, parentBlockId: string}} */
            const paramData = JSON.parse(blockOne.data);
            const reusableBlockId = paramData.parentBlockId;
            const blockTwo = b.getSourceBlock();
            const nearestReusableBlock = this.findNearestSurroundingReusableBlock(blockTwo);
            // we don't want to create parameter out of parameter reference
            if (blockTwo.type === 'vmt_reusable_brick_init_statement') {
                return false;
            }
            else if (blockTwo.type === 'vmt_parameter') {
                const grandSurroundBlock = blockTwo.getSurroundParent().getSurroundParent();
                const nearestReusableBlock = this.findNearestSurroundingReusableBlock(grandSurroundBlock);
                if (nearestReusableBlock && nearestReusableBlock.id === reusableBlockId) {
                    return true;
                }
                return false;
            }
            // we are inside the same reusable block
            else if (nearestReusableBlock && nearestReusableBlock.id === reusableBlockId) {
                // do not allow parameter reference to connect to parameter value
                // of the same reusable block
                if (blockTwo.type === 'vmt_parameter') {
                    return false;
                }
                return true;
            }
            else if (blockTwo.type === 'vmt_parameter') {
                return true;
            }
            return false;
        }

        // // Rule #1
        // if (b?.shadowState?.type === 'vmt_param_drop') {
        //     const blockTwo = b.getSourceBlock();
        //     const nearestReusableBlock = this.findNearestSurroundingReusableBlock(blockOne);
        //     if (nearestReusableBlock && nearestReusableBlock.id === blockTwo.id) {
        //         return true;
        //     }
        //     return false;
        // }

        // Find any intersection in the check lists.
        const intersection = checkArrayOne.filter(x => checkArrayTwo.includes(x));
        if (intersection.length > 0) {
            return true;
        }
        // No intersection.
        return false;
    }

    // doDragChecks(a, b) {
    //     console.log('doDragChecks', a, b);
    //     return super.doDragChecks(a, b);
    // }

    // doSafetyChecks(a, b) {
    //     console.log('doSafetyChecks', a, b);
    //     return super.doSafetyChecks(a, b);
    // }

    /**
     * Is this block enclosed (at any level) by a reusable block?
     *  If so, return the top level block, otherwise return null.
     * @param {!Blockly.Block} block The block to check.
     * @this {Blockly.Block}
     * @return {Blockly.Block} The top level block that encloses this block.
     */
    findNearestSurroundingReusableBlock(block) {
        const loopTypes = new Set(['vmt_reusable_brick_init', 'vmt_reusable_brick_init_statement']);
        // let block = this;
        do {
            if (loopTypes.has(block.type)) {
                return block;
            }
            block = block.getSurroundParent();
        } while (block);
        return null;
    }
}

const connectionCheckerType = Blockly.registry.Type.CONNECTION_CHECKER;
const vmtConnectionCheckerName = 'VMTConnectionChecker';

// Register the checker so that it can be used by name.
Blockly.registry.register(
    connectionCheckerType,
    vmtConnectionCheckerName,
    VMTConnectionChecker
);

export const VmtTypesCheckPluginInfo = {
    [connectionCheckerType]: vmtConnectionCheckerName,
};